
export function orderStops(stops) {

  let sortedStops = [];
  sortedStops = stops.sort((a, b) => a.shape_dist_traveled - b.shape_dist_traveled);
  return sortedStops

}






